import { render, staticRenderFns } from "./GatewayConfig.vue?vue&type=template&id=a1c17d5a&scoped=true"
import script from "./GatewayConfig.vue?vue&type=script&lang=js"
export * from "./GatewayConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c17d5a",
  null
  
)

export default component.exports